import type { StepTypeId } from '@vigeo/shared';
import type { StepUiModule } from './contract.js';
import { infoTaskUi } from './types/info-task.js';
import { pdfFormUi } from './types/pdf-form.js';
import { documentUploadUi } from './types/document-upload.js';
import { candidateApplicationUi } from './types/candidate-application.js';
import { acknowledgmentUi } from './types/acknowledgment.js';
import { dateCredentialUi } from './types/date-credential.js';
import { hrRecordUi } from './types/hr-record.js';
import { externalProcessUi } from './types/external-process.js';
import { healthChoiceUi } from './types/health-choice.js';

/**
 * The UI half of the registry, keyed by the same ids as the kernel's.
 *
 * `satisfies Record<StepTypeId, StepUiModule>` is the whole point: adding a step type to
 * `packages/shared/src/steps/registry.ts` and forgetting the UI is a COMPILE ERROR naming
 * the missing id. The same mechanism the readiness presenters use.
 *
 * There is deliberately NO fallback renderer. ADR-005 §5 wants the compile error, and a
 * fallback is worse than a build break here: it would quietly become a reviewer approving a
 * document through a component that does not properly show it.
 */
export const stepUi = {
  'info-task': infoTaskUi,
  'document-upload': documentUploadUi,
  'candidate-application': candidateApplicationUi,
  'hr-record': hrRecordUi,
  acknowledgment: acknowledgmentUi,
  'date-credential': dateCredentialUi,
  'pdf-form': pdfFormUi,
  'external-process': externalProcessUi,
  'health-choice': healthChoiceUi,
} satisfies Record<StepTypeId, StepUiModule>;

export function findStepUi(id: string): StepUiModule | undefined {
  return Object.prototype.hasOwnProperty.call(stepUi, id)
    ? stepUi[id as StepTypeId]
    : undefined;
}
